function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.12, written by Peter Selinger 2001-2015\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,1132.000000) scale(0.100000,-0.100000)",
  fill: "#23dcc8",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1646 11309 c-429 -38 -836 -234 -1138 -548 -282 -292 -453 -659 -497 -1063 -6 -55 -11 -312 -11 -588 l0 -490 1345 0 1345 0 0 1350 0 1350 -472 -1 c-260 -1 -517 -6 -572 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4310 7815 l0 -3505 3505 0 3505 0 0 2608 c0 1619 -4 2652 -10 2727 -46 563 -335 1056 -800 1367 -258 172 -547 272 -865 298 -75 6 -1108 10 -2727 10 l-2608 0 0 -3505z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 5660 l0 -1350 1345 0 1345 0 0 1350 0 1350 -1345 0 -1345 0 0 -1350z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 2198 c0 -272 5 -533 10 -583 98 -850 755 -1507 1605 -1605 50 -5 311 -10 583 -10 l492 0 0 1345 0 1345 -1345 0 -1345 0 0 -492z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4310 1345 l0 -1345 1350 0 1350 0 0 1345 0 1345 -1350 0 -1350 0 0 -1345z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8620 1345 l0 -1345 490 0 c276 0 533 5 588 11 539 58 1013 346 1317 799 119 178 222 425 264 635 33 164 41 316 41 793 l0 452 -1350 0 -1350 0 0 -1345z"
}));

function SvgLedger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1132.000000pt",
    height: "1132.000000pt",
    viewBox: "0 0 1132.000000 1132.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedger);
export default __webpack_public_path__ + "static/media/ledger.74e19b86.svg";
export { ForwardRef as ReactComponent };